<template>
	<div v-if="user">
		<div class="col-md-12 view-user py-3 px-4">
			<div class="card">
				<div class="card-body">
					<div
						class="d-flex align-items-center justify-content-between mb-3 align-middle"
					>
						<div class="container">
							<div class="row">
								<div class="col text-left" style="display: inline">
									<h3 style="display: inline" class="header-case card-header">
										{{ user.name }}
									</h3>

									<div
										style="display: inline"
										v-if="user.photo_url == `/assets/img/hotel-icon.ico`"
									>
										<h3 class="header-case card-header"></h3>
									</div>
									<div style="display: inline" v-else>
										<img
											style="border-radius: 50%"
											src="user.photo_url"
											class="img-responsive rounded-circle"
											width="50px"
											height="50px"
										/>
									</div>
								</div>

								<div class="col align-right">
									<div class="float-right" v-if="user.verified == 1">
										<h3 class="header-case">
											<i class="fa fa-check text-success"></i>
											Verified
											<button
												class="btn btn-danger"
												@click="deactivateUser(user)"
											>
												DEACTIVATE
											</button>
										</h3>
										<div v-if="user.verified == 1"></div>
									</div>
									<div class="float-right" v-else>
										<span class="header-case">Unverified </span>
										<button class="btn btn-primary" @click="verifyUser(user)">
											Verify
										</button>
									</div>
								</div>
							</div>
							<br />
							<div
								style="gap: 10px"
								class="d-flex align-items-center justify-content-between"
							>
								<div
									style="gap: 10px"
									class="d-flex align-items-center justify-content-start"
								>
									<span class="header-case card-header">Email:</span>
									<h6>{{ user.email }}</h6>
									<span class="btn btn-primary" @click.stop.prevent="copyEmail">
										Copy
									</span>
									<input type="hidden" id="email_copy" :value="user.email" />
								</div>
								<div
									style="gap: 10px"
									class="d-flex align-items-center justify-content-start"
								>
									<span class="header-case card-header">Joined On: </span>
									<h6 class="font-weight-normal">
										{{ formatDate(user.created_at) }}
									</h6>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="metrics row">
				<div class="col-md-6 metric-wrapper border-right">
					<p class="metric-label">
						<strong>Announcements Last Viewed</strong>
					</p>
					<div v-if="user.last_read_announcements_at != null">
						<p class="metric-number">
							{{ formatDate(user.last_read_announcements_at) }}
						</p>
					</div>
					<div v-else>
						<p class="metric-number">Never</p>
					</div>
				</div>
				<div class="col-md-6 metric-wrapper border-right">
					<p class="metric-label">
						<strong>Teams Joined</strong>
					</p>
					<div v-if="teams.length == 0">
						<p class="metric-number">No Teams Joined</p>
					</div>
					<div v-else>
						<p class="metric-number">
							{{ teams.length }}
						</p>
					</div>
				</div>
			</div>
		</div>

		<div class="team-actions mt-4 d-flex justify-content-between">
			<div class="col px-2">
				<a
					href="#"
					class="tab border-bottom text-center d-block w-100 pb-3 light-text"
					:class="{ active: tab == 'userTeams' }"
					@click.prevent="openTab('userTeams')"
					>Teams</a
				>
			</div>
			<div class="col px-2">
				<a
					href="#"
					class="tab border-bottom text-center d-block w-100 pb-3 light-text"
					:class="{ active: tab == 'userSettings' }"
					@click.prevent="openTab('userSettings')"
					>Settings</a
				>
			</div>
			<div class="col px-2">
				<a
					href="#"
					class="tab border-bottom text-center d-block w-100 pb-3 light-text"
					:class="{ active: tab == 'userGroups' }"
					@click.prevent="openTab('userGroups')"
					>Groups</a
				>
			</div>
			<div class="col px-2">
				<a
					href="#"
					class="tab border-bottom text-center d-block w-100 pb-3 light-text"
					:class="{ active: tab == 'userAlerts' }"
					@click.prevent="openTab('userAlerts')"
					>Alerts</a
				>
			</div>
		</div>

		<div class="pt-3">
			<component
				v-bind:is="currentTabComponent"
				:partner="partner"
				:user="user"
				:teams="teams"
			></component>
		</div>
	</div>
	<div v-else>
		<div class="loader d-block text-center">
			<p><i class="fas fa-circle-notch fa-spin"></i></p>
			<p>Loading..</p>
		</div>
	</div>
</template>

<script>
import AdministrationMixin from './AdministrationMixin';
import ManageUserTeams from './tabs/ManageUserTeams';
import ManageUserSettings from './tabs/ManageUserSettings';
import ManageUserGroups from './tabs/ManageUserGroups.vue';
import ManageUserAlerts from './tabs/ManageUserAlerts.vue';
import moment from 'moment';

export default {
	name: 'User',
	props: {
		user: {
			type: Object,
			required: true,
		},
		teams: {
			type: Array,
		},
		partner: {
			type: Object,
		},
	},
	components: {
		ManageUserTeams,
		ManageUserSettings,
		ManageUserGroups,
		ManageUserAlerts,
	},
	mixins: [AdministrationMixin],
	data() {
		return {
			tab: 'userTeams',
		};
	},
	computed: {
		currentTabComponent() {
			switch (this.tab) {
				case 'userTeams': {
					return 'manage-user-teams';
				}
				case 'userSettings': {
					return 'manage-user-settings';
				}
				case 'userGroups': {
					return 'manage-user-groups';
				}
				case 'userAlerts': {
					return 'manage-user-alerts';
				}
			}
			return '';
		},
	},
	methods: {
		openTab(tab) {
			this.tab = tab;
		},
		formatDate: function (date) {
			return moment(date, 'YYYY-MM-DD').format('LL');
		},

		copyEmail() {
			let EmailToCopy = document.getElementById('email_copy');
			EmailToCopy.setAttribute('type', 'text');
			EmailToCopy.select();
			document.execCommand('copy');
			try {
				this.$notify({
					group: 'admin',
					title: 'Success!',
					text: 'The email has been copied succefully.',
					position: 'top right',
					duration: 2000,
				});
			} catch (err) {
				this.$notify({
					group: 'admin',
					title: 'Failure!',
					text: 'Oops! Something went wrong. Please try again.',
					position: 'top right',
					type:"error",
					duration: 2000,
				});
			}
			/* unselect the range */
			EmailToCopy.setAttribute('type', 'hidden');
		},
		async verifyUser(user) {
			await axios.put(`${this.usersUrl}/${user.id}/verify`);
			this.$emit('user-update-triggered', true);
		},
		async deactivateUser(user) {
			await axios.put(`${this.usersUrl}/${user.id}/unverify`);
			this.$emit('user-update-triggered', true);
		},
	},
};
</script>

<style scoped>
.teams-row {
	height: 70vh;
	overflow-y: hidden;
}

.teams-row .col-md-3 {
	height: 100%;
}

.teams-row .col-md-3 .teams {
	max-height: calc(100% - 90px);
	overflow-y: auto;
}

.team {
	font-weight: 600;
	color: #90919e;
}

.team.active {
	color: #00aef1;
	font-weight: 600;
	box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.19);
}

.fa-arrow-right {
	font-size: 10px;
	vertical-align: middle;
}

.view-team {
	overflow-y: auto;
	max-height: 100%;
}

.container {
	margin: 0px;
	margin-top: 1em;
}

.font-weight-normal {
	letter-spacing: 3px;
}

.tab {
	border-bottom-width: 2px;
}

.tab.active {
	color: #00aef1;
	border-bottom: solid 2px #00aef1 !important;
}

h6 {
	line-height: 0;
}
</style>
